module.exports = __webpack_public_path__ + "img/loading_2.d2205068.png";